import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { getStores } from '../services/shopifyApi';

const StoresContext = createContext(null);

export const useStores = () => {
  const context = useContext(StoresContext);
  if (!context) throw new Error('useStores must be used within StoresProvider');
  return context;
};

export const StoresProvider = ({ children }) => {
  const [stores, setStores] = useState([]);
  const [loading, setLoading] = useState(true);

  const refreshStores = useCallback(async () => {
    try {
      const { stores: storeList } = await getStores();
      setStores(storeList);
    } catch (err) {
      console.error('Failed to fetch stores:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refreshStores();
  }, [refreshStores]);

  const activeStores = stores.filter((s) => s.status === 'active');
  const mainStore = stores.find((s) => s.is_main) || activeStores[0] || null;

  return (
    <StoresContext.Provider value={{ stores, activeStores, mainStore, loading, refreshStores }}>
      {children}
    </StoresContext.Provider>
  );
};
